module.exports = __webpack_public_path__ + "img/live-music--icon--gray.8536e7ff.svg";